import apiClient from "./apiClient";

const withoutEmpty = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== "" && value != null),
  );

// The employee is taken from the access token, so "my" endpoints don't
// take an employeeId.
export const leaveService = {
  // LeaveBalance[] with numeric allocated/used/pending/booked/available.
  // `year` defaults to the current year on the server.
  getMyBalances: ({ year, leaveTypeId } = {}) =>
    apiClient.get("/leave/my/balances", {
      params: withoutEmpty({ year, leaveTypeId }),
    }),

  // LeaveRequest[] newest first. Filters: status (lowercase), year, leaveTypeId.
  getMyRequests: (filters = {}) =>
    apiClient.get("/leave/my/requests", { params: withoutEmpty(filters) }),

  // { leaveTypeId, startDate, endDate, totalDays (0.5 steps), reason }
  fileLeave: (data) => apiClient.post("/leave/my/request", data),

  // Allowed while pending, or approved but not started yet.
  cancelMyLeave: (id) => apiClient.patch(`/leave/my/${id}/cancel`),
};
